import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useRolesListFetch = () => {
  const response = useQuery({
    queryKey: ['rolesList'],
    queryFn: () => api.keycloak.fetchRolesList(),
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить список ролей',
      type: 'error',
    })
  }

  return response
}
